import React, { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import privateAxios from '../../utils/axios/privateAxios';
import publicAxios from '../../utils/axios/publicAxios';
import './CreateReport.css';
import Notification from '../../components/Notification/Notification';
import { Link, useNavigate } from 'react-router-dom';
import { formats, modules, reportCategories } from '../../assets/exports';

const CreateReport = () => {
    const [title, setTitle] = useState('');
    const [year, setYear] = useState('');
    const [content, setContent] = useState('');
    const [display, setDisplay] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);
    const [pdfName, setPdfName] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');
    const [category, setCategory] = useState('');
    const [notification, setNotification] = useState({ type: '', message: '' });

    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    const userId = localStorage.getItem('userId');
    const navigate = useNavigate();

    const handlePdfChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setPdfFile(file);
        setPdfName(file.name);
    };

    const uploadPdfToS3 = async () => {
        if (!pdfFile) return '';

        try {
            const response = await privateAxios.get('/private/generate-pdf-upload-url', {
                params: {
                    filename: pdfFile.name,
                    filetype: pdfFile.type,
                },
            });

            const { url } = response.data;
            await publicAxios.put(url, pdfFile);
            return url.split('?')[0];
        } catch (error) {
            console.error('PDF upload failed:', error);
            throw new Error('Failed to upload PDF.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus('');

        let uploadedPdfUrl = '';

        try {
            if (pdfFile) {
                uploadedPdfUrl = await uploadPdfToS3();
            }

            const reportData = {
                title,
                year,
                content,
                display,
                category,
                pdfUrl: uploadedPdfUrl || '',
            };

            await privateAxios.post(`/private/create-report`, reportData);

            setStatus('Report posted successfully!');
            showNotification('success', 'Report created successfully!');
            setTitle('');
            setYear('');
            setContent('');
            setDisplay(false);
            setPdfFile(null);
            setPdfName('');
            setCategory('');
            setTimeout(() => {
                navigate('/admin-reports');
            }, 3000);
        } catch (error) {
            console.error(error);
            showNotification('error', error.message || 'Error posting report.');
            setStatus('Error posting report.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="create-report-container">
            <Notification
                type={notification.type}
                message={notification.message}
                onClose={() => setNotification({ type: '', message: '' })}
            />
            <Link to={'/admin-reports'} className="create-report-back-to-reports">
                Back to Reports
            </Link>

            <h2>Create Report</h2>

            <form onSubmit={handleSubmit}>
                {/* Title */}
                <label>Title:</label>
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />

                {/* Year */}
                <label>Year:</label>
                <input
                    type="text"
                    className='create-report-year-input'
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    placeholder="Enter year (e.g., 2025 - 2026)"
                    required
                />

                {/* Content */}
                <label>Content:</label>
                <ReactQuill
                    value={content}
                    onChange={setContent}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                />

                <label>Category:</label>
                <select className='create-report-select-category' value={category} onChange={(e) => setCategory(e.target.value)} required>
                    {reportCategories.map((c) => (
                        <option key={c} value={c}>
                            {c.charAt(0).toUpperCase() + c.slice(1)}
                        </option>
                    ))}
                </select>

                {/* Display checkbox */}
                <label className="checkbox-label">
                    <input
                        type="checkbox"
                        checked={display}
                        onChange={() => setDisplay(!display)}
                    />
                    Display
                </label>

                {/* PDF upload */}
                <label>Upload PDF (optional):</label>
                <input type="file" accept="application/pdf" onChange={handlePdfChange} style={{ padding: 0 }} />
                {pdfName && (
                    <div className="uploaded-pdf-preview">
                        <p>Selected file: {pdfName}</p>
                    </div>
                )}

                {/* Submit */}
                <button type="submit" disabled={loading}>
                    {loading ? 'Creating Report...' : 'Post Report'}
                </button>
            </form>

            {status && <p className="status-message">{status}</p>}
        </div>
    );
};

export default CreateReport;